import {type PreviewCommand} from '../../commands/preview.js'

export type PreviewFlags = PreviewCommand['flags']
